import styled from 'styled-components';

const AreaFact = styled.div`
  width: 70%;
  height: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Fact = styled.p`
  padding-left: 20px;
  padding-right: 20px;
  letter-spacing: 2px;
`;

export { AreaFact, Fact };
